export enum PlanningTaskType {
  Manual = "Manual",
  TriggerOrderSchedule = "TriggerOrderSchedule",
}
